import jwtDecode from 'jwt-decode';

import { TokenUtils } from '@altirllc/shared/utils/tokenUtils';

import type { TTokenContent } from '@/types/auth';

import { storage } from '@/storage';

// @ToDo: Revisit this - `getUserIdFromToken` won't work for HF
export const tokenUtils = new TokenUtils(storage);

export const parseToken = (accessToken = tokenUtils.getLocallyStoredToken()) =>
  jwtDecode<TTokenContent>(accessToken);
